import { Resource } from 'src/app/global/domain/resource.model';
import { Posto } from './posto.model';
import { Bairro } from './bairro.model';

export class AreaAtuacao extends Resource {
  nome: string;
  listBairro: Bairro[];
  posto: Posto;
}
